import React from 'react'

const References  = () => {
    return (
        <>

{/* References container start */}
<div className="flex flex-wrap lg:flex-nowrap items-center mb-20">
                {/* References container start */}
                <div className="w-full">
                    <ol className="list-decimal pl-6 space-y-4">
                        <li className="text-sm 2xl:text-base text-blue-primary font-bold">
                            <p className = "font-normal feature-p-text pl-3 ">Khsettry et al. </p>
                            <p className = "feature-p-text  pl-3 ">
                                Prospective Study of Mitral Valve Repair with the CarboMedics 
                                AnnuloFlex<sup>TM</sup> Annuloplasty System: <br/> Effectiveness and Safety 
                                after One Year.</p>
                            <p className = "font-normal italic feature-p-text pl-3 ">
                                The Journal of Heart Valve Disease 2005;14:105-113
                            </p>
                        </li>
                        <li className="text-sm 2xl:text-base text-blue-primary font-bold">
                            <p className = "font-normal feature-p-text pl-3 ">
                            Pragliola et al.</p>
                            <p className = "feature-p-text  pl-3 ">
                                Long-term results of an open flexible prosthetic band 
                                for mitral insufficiency. </p>
                            <p className = "font-normal italic feature-p-text pl-3 ">
                                Asian Cardiovascular {"&"} Thoracic Annals 2014, 
                                Vol. 22(7) 811–815</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-blue-primary font-bold">
                            <p className = "font-normal feature-p-text pl-3  ">
                                Khsettry et al. </p>
                            <p className = "feature-p-text  pl-3 ">
                                Current Trends in Mitral Valve Repair Techniques in North America. 
                            </p>
                            <p className = "font-normal italic feature-p-text pl-3 ">
                                 Journal of Heart Valve Disease 2012;21:690-695</p>
                        </li>

                        <p className = "feature-p-text font-bold">
                            Technical claims supported by CORCYM data on file 
                        </p>
                            
                    </ol>
                    
                </div>
                {/* feature text container end */}
            </div>
            {/* feature container end */}

        </>
    )
}

export default References 
